<template>
  <div class="d-flex flex-column align-end justify-center background" style="width: 50vw">
    <div style="max-width: 600px" class="desktop-card">
      <img
        src="@/assets/logo/logo.png"
        alt=""
        style="max-height: 80px; max-width: 150px"
        class="mb-4 bullet-point-subheader"
      />
      <div class="bullet-point hover">
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="primary" icon="star" />
          <h3>Get started in minutes</h3>
        </div>
        <div class="bullet-point-subheader">
          Create your account now -- we'll guide you through setup step by
          step.
        </div>
      </div>
      <div class="bullet-point hover">
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="primary" icon="star" />
          <h3>Set up your stores your way</h3>
        </div>
        <div class="bullet-point-subheader">
          Configure branding, pricing, and your team in a few guided steps.
        </div>
      </div>
      <div class="bullet-point hover">
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="primary" icon="star" />
          <h3>Sell and fulfill, end to end</h3>
        </div>
        <div class="bullet-point-subheader">
          Launch branded online stores -- pop-ups, team shops, company
          stores -- and route every order to suppliers and decorators
          automatically.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignUpSidebar",
};
</script>

<style scoped>
.background {
  height: 100vh;
  background-color: #f5f8fa;
}

.desktop-card {
  padding-right: 25px;
  padding-left: 25px;
  max-width: 600px;
  border-radius: 10px;
  max-height: 850px;
  z-index: 1;
}

.bullet-point {
  margin-bottom: 25px;
}

.bullet-point-subheader {
  padding-left: 32px;
}

.hover {
  z-index: 5px;
  position: relative;
}
</style>
